import React, { useState } from "react";
import clsx from "clsx";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
} from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import Image from "../../../components/Image";

const caseInfo = {
	author: "Shengwei Zhu",
	source: "Shengwei Zhu",
};

export default function AirplaneCabin() {
	return (
		<TabPane tabId={"airplane"} style={{ width: "100%" }}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>Airplane Cabin: Fewer Passengers, Lower Risk</h4>
				</Col>
				<Col xs="12" sm={{ size: 12 }} style={{ paddingBottom: 6 }}>
					<h6>Main Findings: </h6>
					<p style={{ fontStyle: "italic" }}>
						Studies currently show and the general concensus is that fewer
						passengers in airplane cabins reduce risk of COVID-19 due to the
						reduction in number of potentially infected passengers and the
						relative per person increase in fresh filtered air to the cabin. Our
						study also shows a third important factor, this being the less
						obstructed airflow in the reduced passenger capacity cabin setup
						yielded a faster dilution of infectious aerosols and the associated
						significant risk reduction compared to the risk for the same
						passengers in a fully occupied airplane cabin.
					</p>
				</Col>
				<Col xs="12" sm={{ size: 12 }} style={{ paddingBottom: 6 }}>
					<h6>Description:</h6>
					<p>
						The animation below shows the spread of viral aerosols in a section
						of an aircraft cabin mockup with a dimension of 4.9 m × 5.6 m × 2.1
						m based upon the valided cabin structure and boundry conditions of
						Wan, MP, et al <sup>[1]</sup>. Inside the cabin are 42 seats
						arranged in three rows of seven seats with two aisles (2x3x2
						arrangement). Supply air is distributed through two overhead slots
						located at the middle part of the ceiling, towards the two side
						walls. There is an outlet located at each of the side walls near the
						floor. Two cases were simulated with different occupancies: one with
						full occupancy and the other with half occupancy. The flow rate of
						air supply was determined according to the requirement for full
						occupancy, with 9 l/s per passenger, resulting in a total air
						exchange rate of 28 ACH for the cabin, Sze To, GN, et al.
						<sup>[2]</sup>.
					</p>
				</Col>
				<Col xs="12" sm={{ size: 12 }} style={{ paddingBottom: 6 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">
								Case 1: Airplane Cabin Full Capacity
							</h5>
							<figure className="figure">
								<Image src={`images/covid/airplane/fullcabin.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of the path of exhaled particles from infected
									occupant in a full capacity section of an airplane cabin.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<h5 className="text-center">
								Case 2: Airplane Cabin Half Capacity
							</h5>
							<figure className="figure">
								<Image src={`images/covid/airplane/halfcabin.gif`} alt="" />

								<figcaption className="figure-caption">
									Animation of the path of exhaled particles from infected
									occupant in a half capacity section of airplane cabin.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs="12" sm={{ size: 12 }} style={{ paddingBottom: 6 }}>
					<p>
						Case 1 shows a section of an airplane cabin at full capacity,
						totaling 42 passengers in the cabin. The infected passenger is
						seated in the middle of the 4th row. The viral aerosols emitted from
						the infected passenger rise up to the ceiling, then most of the
						aerosols are spread to the front. A few of the aerosols are soon
						exhausted from the cabin by the outlet, but most stay in the space
						between the two aisles for a couple of minutes. The passengers
						sitting in front of the infected people are at greater risk to get
						infected.
					</p>
					<p>
						Case 2 shows an airplane cabin at half capacity where the passengers
						sit on every other seat; totaling 28 passengers in the cabin. The
						infected person is seated in the 3th row at the aisle side. As shown
						in the animation, the viral aerosols emitted by the infected person
						rise up to the ceiling, and then are spread to the front. We can see
						that some aerosols are spread to the opposite side of the cabin and
						exhausted by the outlet at the opposite side. With the half
						occupancy, some aerosols stay a couple of minutes in the cabin, and
						result in a threat to all of the passengers sitting in front of the
						infected people.
					</p>
				</Col>
				<Col xs={12}>
					<p style={{ fontSize: 10, color: "grey" }}>
						[1]: Wan, MP, et al. Aerosol Science and Technology 2009, 43:4,
						322-343, DOI: 10.1080/02786820802641461
					</p>
					<p style={{ fontSize: 10, color: "grey" }}>
						[2]: Sze To, GN, et al. Aerosol Science and Technology 2009, 43:5
						466-485, DOI: 10.1080/02786820902736658
					</p>
				</Col>
			</Row>
		</TabPane>
	);
}
